import { Button } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { RECORD_STATE } from "Constants";
import { useStoreState } from "easy-peasy";
import React from "react";

export default function DeleteButton({ record, actions, loading, ...props }) {
  const { abilities } = useStoreState((store) => store.auth);

  return (
    <>
      {record?.state === RECORD_STATE.ACTIVE && (
        <Button
          type="danger"
          disabled={!AuthCheck(abilities, AUTH_ACTIONS.DELETE, "Birimler")}
          loading={loading}
          onClick={() =>
            actions.remove({ id: record?.id, version: record?.version })
          }
        >
          Sil
        </Button>
      )}
      {record?.state === RECORD_STATE.DELETED && (
        <Button
          disabled={
            !AuthCheck(abilities, AUTH_ACTIONS.RESTORE_ARCHIVE, "Birimler")
          }
          onClick={() =>
            actions.restore({ id: record.id, version: record.version })
          }
        >
          Arşivden Geri Al
        </Button>
      )}
    </>
  );
}
